// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"23":"965fd6f1","699":"c910a7b0","860":"64ffc092"}[chunkId] + ".js";
};